<template>
    <div>
        <v-btn :class="fullWidth ? 'w-100' : ''" v-if="activeButton" v-ripple="false" :loading="loading" @click="clicked" class="blue--text drop-button button-secondary-active">
            <p class="text-wrap ma-0">
                <slot></slot>
            </p>
        </v-btn>
        <v-btn :class="fullWidth ? 'w-100' : ''" v-else :loading="loading" class=" drop-button button-secondary-disabled disable-events">
            <p class="text-wrap ma-0">
                <slot></slot>
            </p>
        </v-btn>
    </div>
</template>
<script>
export default {
    props: ['activeButton', 'clickBtn', 'goToHref', 'loading', 'fullWidth'],
    data:()=>{
        return {

        }
    },
    methods: {
        clicked(){
            if(this.goToHref){
                location.href = location.origin+this.goToHref;
            } else {
                this.$emit('clickBtn');
            }
        }
    }
}
</script>
<style>
.disable-events {
    pointer-events: none
}
</style>
